<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40">
  <path
    d="M11.875 20A4.376 4.376 0 0 1 7.5 24.375 4.376 4.376 0 0 1 3.125 20 4.376 4.376 0 0 1 7.5 15.625 4.376 4.376 0 0 1 11.875 20Zm12.5 0A4.378 4.378 0 0 1 20 24.375 4.378 4.378 0 0 1 15.625 20 4.378 4.378 0 0 1 20 15.625 4.378 4.378 0 0 1 24.375 20Zm3.75 0a4.378 4.378 0 0 1 4.375-4.375A4.378 4.378 0 0 1 36.875 20a4.378 4.378 0 0 1-4.375 4.375A4.378 4.378 0 0 1 28.125 20Z"
  />
</svg>
